import { useState } from "react";
import useDimensions from "react-cool-dimensions";
import { limitNumberBetween } from "../../common/utils";
import { useForceRerender } from "./useForceRerender";
/**
 * Returns position of target element, snapped(magnetic effect) state flag,
 * setting position functions.
 *
 * - setPosition: limit the position between min and max size
 * - setCalcPosition: check the position and if the offset from bounds is
 * less than `magneticOffset`, it will snap the element into the bounds.
 */
export function useGetPosition(props) {
    var _a = useDimensions(), observe = _a.observe, entry = _a.entry, width = _a.width, height = _a.height;
    var _b = useState({ x: 0, y: 0 }), position = _b[0], _setPosition = _b[1];
    var _c = useState(false), snappedBottom = _c[0], setSnappedBottom = _c[1];
    // Set the toolbar position within the min and max
    var setPosition = function (x, y) {
        var _a, _b, _c, _d;
        var newX = limitNumberBetween(x, (_a = props.min) === null || _a === void 0 ? void 0 : _a.x, (_b = props.max) === null || _b === void 0 ? void 0 : _b.x);
        var newY = limitNumberBetween(y, (_c = props.min) === null || _c === void 0 ? void 0 : _c.y, (_d = props.max) === null || _d === void 0 ? void 0 : _d.y);
        _setPosition({ x: newX, y: newY });
    };
    // If the toolbar is nearby edge bounds, it will change the position
    // to snap into the bounds (i.e. magnetic effect)
    var calcPosition = function (currentX, currentY) {
        var boundElement = window.document.querySelector(props.boundSelector);
        if (!boundElement || !(entry === null || entry === void 0 ? void 0 : entry.target)) {
            return { x: currentX, y: currentY };
        }
        var boundElementStyle = window.getComputedStyle(boundElement);
        var toolbarElementStyle = window.getComputedStyle(entry.target);
        var boundSizeWithoutPadding = {
            width: boundElement.clientWidth -
                parseInt(boundElementStyle.paddingLeft) -
                parseInt(boundElementStyle.paddingRight),
            height: boundElement.clientHeight -
                parseInt(boundElementStyle.paddingTop) -
                parseInt(boundElementStyle.paddingBottom),
        };
        var toolbarSize = {
            width: width,
            height: height + parseInt(toolbarElementStyle.marginBottom),
        };
        var calcX, calcY;
        if (currentX < props.magneticOffset) {
            calcX = 0;
        }
        else if (currentX + toolbarSize.width >
            boundSizeWithoutPadding.width - props.magneticOffset) {
            calcX = boundSizeWithoutPadding.width - toolbarSize.width;
        }
        else {
            calcX = currentX;
        }
        setSnappedBottom(false);
        if (currentY < props.magneticOffset) {
            calcY = 0;
        }
        else if (currentY + toolbarSize.height >
            boundSizeWithoutPadding.height - props.magneticOffset) {
            calcY = boundSizeWithoutPadding.height - toolbarSize.height;
            setSnappedBottom(true);
        }
        else {
            calcY = currentY;
        }
        return {
            x: calcX,
            y: calcY,
        };
    };
    var setCalcPosition = function (currentX, currentY) {
        var _a = calcPosition(currentX, currentY), x = _a.x, y = _a.y;
        setPosition(x, y);
    };
    var forceUpdatePosition = useForceRerender(function () {
        setCalcPosition(position.x, position.y);
    });
    return [
        observe,
        position,
        { width: width, height: height },
        snappedBottom,
        setPosition,
        setCalcPosition,
        forceUpdatePosition,
    ];
}
